import React, { useState, useEffect } from 'react';
import CalendarModal from '../CalendarModal/CalendarModal';
import api from '../../services/api';

const DoctorServicesPage = ({ onBack, onAddToCart, onAddMultipleToCart, onShowCartNotification, doctor }) => {
  const [selectedServices, setSelectedServices] = useState([]);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Загрузка УСЛУГ ВРАЧА из таблицы doctor_services
  useEffect(() => {
    const fetchDoctorServices = async () => {
      if (!doctor?.id) {
        setLoading(false);
        return;
      }
      
      try {
        const doctorServices = await api.getDoctorServices(doctor.id);
        const mappedServices = doctorServices.map((service) => ({
          id: service.id,
          service_id: service.id,
          name: service.name,
          price: service.price,
          description: service.description
        }));
        setServices(mappedServices);
      } catch (err) {
        console.error('Ошибка загрузки услуг врача:', err);
        setError('Не удалось загрузить услуги врача');
      } finally {
        setLoading(false);
      }
    };
    
    fetchDoctorServices();
  }, [doctor]);

  const toggleService = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleAddSelectedToCart = () => {
    if (selectedServices.length === 0) {
      showNotification('Выберите хотя бы одну услугу');
      return;
    }

    const selectedServicesData = services.filter(service => 
      selectedServices.includes(service.id)
    );
    
    selectedServicesData.forEach(service => {
      const cartItem = {
        id: service.id,
        service_id: service.id,
        name: service.name,
        price: service.price,
        category: doctor.specialty,
        doctor: doctor.name,
        isDoctorService: true
      };
      onAddToCart(cartItem);
    });

    if (onShowCartNotification) {
      onShowCartNotification(selectedServicesData.length);
    }

    setSelectedServices([]);
  };

  const handleBookAppointment = () => {
    if (selectedServices.length > 0) {
      setShowCalendarModal(true);
    } else {
      showNotification('Выберите услуги для записи');
    }
  };

  const handleCalendarConfirm = (selectedDate) => {
    const formattedDate = `${selectedDate.date.getDate().toString().padStart(2, '0')}.${(selectedDate.date.getMonth() + 1).toString().padStart(2, '0')}.${selectedDate.date.getFullYear()}`;
    const dayOfWeek = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'][selectedDate.date.getDay()];
    
    const selectedServicesData = services.filter(service => 
      selectedServices.includes(service.id)
    );
    
    selectedServicesData.forEach(service => {
      const cartItem = {
        id: service.id,
        service_id: service.id,
        name: service.name,
        price: service.price,
        category: doctor.specialty,
        doctor: doctor.name,
        date: `${formattedDate} (${dayOfWeek})`,
        isDoctorService: true
      };
      onAddToCart(cartItem);
    });
    
    if (onShowCartNotification) {
      onShowCartNotification(selectedServicesData.length);
    }
    
    setSelectedServices([]);
    setShowCalendarModal(false);
  };

  const showNotification = (message) => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.showAlert(message);
    } else {
      alert(message);
    }
  };

  const totalPrice = services
    .filter(service => selectedServices.includes(service.id))
    .reduce((sum, service) => {
      const priceStr = service.price?.toString().replace(/[^\d.]/g, '') || '0';
      return sum + (parseInt(priceStr) || 0);
    }, 0);

  const getServiceNames = () => {
    return selectedServices.map(id => {
      const service = services.find(s => s.id === id);
      return service?.name || '';
    }).filter(Boolean).join(', ');
  };

  if (loading) {
    return (
      <div className="doctor-services-page">
        <div className="services-header">
          <button className="service-btn back-btn" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">Назад к врачам</span>
          </button>
        </div>
        <div className="loading-spinner" style={{ textAlign: 'center', padding: '40px', color: 'white' }}>
          Загрузка услуг врача...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="doctor-services-page">
        <div className="services-header">
          <button className="service-btn back-btn" onClick={onBack}>
            <span className="btn-icon">←</span>
            <span className="btn-text">Назад к врачам</span>
          </button>
        </div>
        <div className="error-message" style={{ textAlign: 'center', padding: '40px', color: '#e74c3c' }}>
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="doctor-services-page">
      <div className="services-header">
        <button className="service-btn back-btn" onClick={onBack}>
          <span className="btn-icon">←</span>
          <span className="btn-text">Назад к врачам</span>
        </button>
      </div>

      <div className="doctor-services-header">
        <div className="doctor-services-photo">
          <div className="doctor-photo-frame-small">
            <img 
              src={doctor.photo || doctor.image_url} 
              alt={doctor.name}
              className="doctor-photo-img-small"
              onError={(e) => {
                e.target.style.display = 'none';
                let fallbackIcon = "👨‍⚕️";
                const specialties = {
                  'Кардиолог': '❤️', 'Невролог': '🧠', 'Терапевт': '👨‍⚕️',
                  'Хирург': '🔪', 'Педиатр': '👶', 'Оториноларинголог': '👂',
                  'Психиатр': '🧠', 'Дерматолог': '🌸', 'Офтальмолог': '👁️',
                  'Стоматолог': '🦷', 'Гинеколог': '👩‍⚕️', 'Психолог': '💭'
                };
                fallbackIcon = specialties[doctor.specialty] || '👨‍⚕️';
                e.target.parentElement.innerHTML = 
                  `<div class="doctor-photo-fallback-small">${fallbackIcon}</div>`;
              }}
            />
          </div>
        </div>
        <div className="doctor-services-title">
          <h2>{doctor.specialty?.toUpperCase()}</h2>
          <p className="doctor-full-name">{doctor.name}</p>
        </div>
      </div>

      <div className="services-list-section">
        <div className="section-divider">
          <h3>Услуги врача</h3>
        </div>

        <div className="services-scroll-container">
          {services.length > 0 ? (
            services.map((service) => (
              <div 
                key={service.id}
                className={`service-item ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                onClick={() => toggleService(service.id)}
              >
                <div className="service-checkbox">
                  {selectedServices.includes(service.id) ? '✓' : ''}
                </div>
                <div className="service-details">
                  <h4 className="service-item-name">{service.name}</h4>
                  <div className="service-price">{service.price} ₽</div>
                  {service.description && (
                    <p className="service-description" style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginTop: '5px' }}>
                      {service.description}
                    </p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="no-services" style={{ textAlign: 'center', padding: '40px', color: 'rgba(255,255,255,0.7)' }}>
              <p>У этого врача пока нет услуг</p>
              <p style={{ fontSize: '13px', marginTop: '10px' }}>Пожалуйста, обратитесь в клинику для записи</p>
            </div>
          )}
        </div>
      </div>

      <div className="services-footer">
        {selectedServices.length > 0 && (
          <div className="selected-services-summary">
            <div className="summary-header">
              <span className="summary-label">Выбрано услуг</span>
              <span className="summary-badge">{selectedServices.length}</span>
            </div>
            
            <div className="summary-total">
              <span className="total-label">Общая сумма</span>
              <span className="total-amount">{totalPrice.toLocaleString()} ₽</span>
            </div>

            <div className="summary-actions">
              <button 
                className="action-btn book-action"
                onClick={handleBookAppointment}
              >
                <span className="action-icon">📅</span>
                <span className="action-text">Записаться</span>
              </button>

              <button 
                className="action-btn cart-action"
                onClick={handleAddSelectedToCart}
              >
                <span className="action-icon">🛒</span>
                <span className="action-text">В корзину</span>
              </button>
            </div>
          </div>
        )}
      </div>

      <CalendarModal
        isOpen={showCalendarModal}
        onClose={() => setShowCalendarModal(false)}
        onConfirm={handleCalendarConfirm}
        serviceName={`${doctor.specialty}: ${getServiceNames().substring(0, 50)}${getServiceNames().length > 50 ? '...' : ''}`}
        servicePrice={`${totalPrice.toLocaleString()} ₽`}
      />
    </div>
  );
};

export default DoctorServicesPage;